module.exports = __webpack_public_path__ + "img/icon_body_pain.1d6d9896.svg";